import type { DataTableColumn } from '@/components/custom/erp';
import type { ChiTietPhieuNhapKho } from '@/types/schemas';
import { usePasteConfig } from '@/components/custom/erp';

type DetailPasteConfig = Record<string, { resolver: (codes: string[]) => Promise<unknown[]>; resultField?: string }>;

interface UseDetailPasteProps {
  columns: DataTableColumn<ChiTietPhieuNhapKho>[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (configs: DetailPasteConfig) => void;
}

export const useDetailPaste = ({
  columns,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs
}: UseDetailPasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
